"use strict";import{tag as i}from"../custom-tag.js";export function interactiveIcon({height:t=16,width:e=16,hidden:a=!1,title:r="Interactive"}={}){return i`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="interactive_svg__mask0_6875_6301"
        width="18"
        height="20"
        x="3"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M20.946 11.947c0-.923-.762-1.662-1.714-1.662-.598 0-1.142.317-1.442.791v-.052c0-.924-.761-1.663-1.713-1.663-.599 0-1.143.317-1.442.766v-.053c0-.924-.761-1.662-1.713-1.662-.599 0-1.143.316-1.442.765V3.662c0-.448-.19-.87-.49-1.187A1.72 1.72 0 0 0 9.795 2c-.952 0-1.714.739-1.714 1.662V13.9c0 .105-.054.184-.136.21-.082.027-.19.027-.245-.052l-1.74-1.662a1.81 1.81 0 0 0-2.204-.211c-.408.263-.68.686-.734 1.16-.082.476.082.95.38 1.32l4.326 5.066A6.52 6.52 0 0 0 12.677 22h2.693a5.68 5.68 0 0 0 3.97-1.61c1.062-1.029 1.66-2.4 1.66-3.852z"
        />
      </mask>
      <g mask="url(#interactive_svg__mask0_6875_6301)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=interactive.js.map
